import { useContext } from 'react';

import PopupContext from '../../../../../context/context-popup';

import Popup from '../../../../../components/popup';

import { DeleteButton, CancelButton } from '../../../../../components/buttons';

import ELearningAPI from '../../../../../lib/e-learning/e-learning-api';

export default function CourseRemove({ learningPathId, id, onSuccess }) {
    const { setPopup } = useContext(PopupContext);
    
    const removeCourse = async () => {
        return new ELearningAPI().removeCourseFromLearningPath(learningPathId, { course_id: id });
    }

    const clicked = () => {
        new ELearningAPI().deleteCourse(id).then(async () => {
            const action = await removeCourse();

            if (action) onSuccess();
        });
    }

       return (
        <Popup onClose={setPopup}>
            <div class="popup__inner">
                <h1>Are you sure?</h1>

                <div class="popup__buttons">
                    <DeleteButton responsive={false} onClick={clicked}/>
                    <CancelButton responsive={false} onClick={() => setPopup(null)}/>
                </div>
            </div>
        </Popup>
    )
}
